import {
  getTenantId,
  logWorkspace,
  requireUser,
  updateUserStatus,
} from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionOfferedEvent,
} from '../../types/ServiceEvents';

/**
 * The offer event indicates that a session is being offered to
 * the recipient from a queue.
 * @param event
 */
async function handleAgentSessionOffered(
  event: Telecom.AgentSessionOfferedEvent,
) {
  const user = await requireUser(event.agentId);
  logWorkspace('service:agent:session_offered:' + user.name, event);

  user.available = event.available;
  user.availabilityState = 'Call-Offer';
  user.stats = userStatsFromAgentStats(event.stats);

  // update our status. can't change status while offered a call
  updateUserStatus(user.id, undefined, false);

  appManager.events.emit<ServiceSessionOfferedEvent>(
    ServiceSessionEventType.OFFERED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      agentId: event.agentId,
      userId: user.id,
      from: event.source.address,
      displayName: event.source.displayName ?? '',
      tenantId: getTenantId(event.tenantId, event.agentId),
      queueId: event.queueId,
      queueName: event.queueName,
      queueEnterTime: event.queueEnterTime,
    },
  );
}

export default handleAgentSessionOffered;
